/**
 * Directory Entity Schemas
 *
 * Types for directories and directory entries.
 */

import { z } from 'zod'

/**
 * Directory Type Schema
 */
export const DirectoryTypeSchema = z.enum(['STUDENTS', 'FACULTY', 'STAFF', 'PARENTS', 'ALUMNI', 'CUSTOM'])
export type DirectoryType = z.infer<typeof DirectoryTypeSchema>

/**
 * Directory Entry Schema
 */
export const DirectoryEntrySchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().nullable().optional(),
  phone: z.string().nullable().optional(),
  photoUrl: z.string().nullable().optional(),
  title: z.string().nullable().optional(),
  department: z.string().nullable().optional(),
  gradeLevel: z.string().nullable().optional(),
  roles: z.array(z.string()).optional()
})

export type DirectoryEntry = z.infer<typeof DirectoryEntrySchema>

/**
 * Directory Schema
 */
export const DirectorySchema = z.object({
  id: z.string(),
  name: z.string(),
  type: DirectoryTypeSchema,
  description: z.string().nullable().optional(),
  schoolId: z.string(),
  entryCount: z.number().optional(),
  isEnabled: z.boolean().optional(),
  isSearchable: z.boolean().optional(),
  visibleFields: z.array(z.string()).optional(),
  createdAt: z.string(),
  updatedAt: z.string()
})

export type Directory = z.infer<typeof DirectorySchema>

/**
 * Directory with Entries Schema
 */
export const DirectoryWithEntriesSchema = DirectorySchema.extend({
  entries: z.array(DirectoryEntrySchema).optional()
})

export type DirectoryWithEntries = z.infer<typeof DirectoryWithEntriesSchema>
